import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  createRoutableExtension,
  BackstagePlugin,
  RouteRef,
  identityApiRef,
} from "@backstage/core-plugin-api";
import { opsgenieApiRef, OpsgenieApi } from "./api";
import { rootRouteRef } from "./routes";

export const opsgenieApiPlugin: BackstagePlugin<
  {
    root: RouteRef<undefined>;
  },
  {},
  {}
> = createPlugin({
  id: "opsgenie-api",
  apis: [
    createApiFactory({
      api: opsgenieApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new OpsgenieApi({
          discoveryApi,
          identityApi,
        }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const OpsgeniePage = opsgenieApiPlugin.provide(
  createRoutableExtension({
    name: "OpsGeniePage",
    component: () =>
      import("./components/OpsgeniePage").then((m) => m.OpsgeniePage),
    mountPoint: rootRouteRef,
  })
);
